var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M17.408 15.794c.464 0 .842.383.842.853a.85.85 0 0 1-.842.853H12.65a.85.85 0 0 1-.842-.853c0-.47.377-.853.842-.853zm-3.3-12.711 1.23.976c.503.394.84.914.954 1.46.133.601-.008 1.192-.406 1.702L8.564 16.69c-.336.43-.832.672-1.362.68l-2.918.037a.33.33 0 0 1-.328-.26l-.663-2.876c-.115-.528 0-1.075.336-1.496L8.82 6.057a.26.26 0 0 1 .354-.045l2.184 1.738c.141.116.336.179.54.152a.787.787 0 0 0 .68-.869.88.88 0 0 0-.274-.528l-2.122-1.702a.315.315 0 0 1-.053-.439l.822-1.066c.76-.977 2.087-1.066 3.157-.215"
  })));
};
export default SvgEditIcon;